module.exports = "<div class=\"container page-actions\">\n    <div class=\"top__info\">\n        <ng-template ngFor let-item [ngForOf]=\"menuDashboards\" let-i=\"index\" [ngForTrackBy]=\"trackByIndex\">\n            <a href='#' class=\"top_left_item\" [ngClass]=\"UpdateFirstDashboard(i)\" [textContent]=\"item.name\" (click)=\"SelectDashboard(i,$event)\"></a>\n        </ng-template>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/up-menu/html/dashboard-up-menu.component.html
// module id = ./src/app/components/dashboard/up-menu/html/dashboard-up-menu.component.html
// module chunks = main